import type { CheckLobAddressQueryVariables, CheckLobAddressQuery } from '@/gql/graphql';

export type CheckLobAddressInput = CheckLobAddressQueryVariables;
export type LobAddress = Extract<CheckLobAddressQuery['checkLobAddress'], {}>;

export interface GeoLocationType {
  lat: number | null;
  lng: number | null;
}

export interface Point {
  lat: number;
  lng: number;
}

export interface Address {
  streetAddress: string;
  streetAddress2?: string;
  city: string;
  state: string;
  zip: string;
  country?: string;
  postalCode?: string;
}

export interface MapMarker {
  position: Point;
  index: number;
  isDraggable: boolean;
  isClickable?: boolean;
  isShow: boolean;
  icon: string | google.maps.Symbol;
  initialPosition?: Point;
  label?: string;
  zIndex?: number;
}

export interface MapCustomMarker {
  key: string;
  position: Point;
  label: string;
  color: string;
  isLabelVisible: boolean;
  isHighlighted: boolean;
  hasRing?: boolean;
  zIndex?: number;
}

export interface LocationDataType extends Address {
  streetNumber?: string; // Street Number
  intersection?: string[]; // Interaction Address
  route?: string; // Route
  latitude?: number | null; // Geocode
  longitude?: number | null; // Geocode
  googlePlaceId?: string | null;
  googlePlaceTypes?: string[] | null;
  locationId?: string | null;
  zoneId?: string | null;
  venueId?: string | null;
}

export interface CustomLocationType extends LocationDataType {
  id?: string | null;
  name?: string | null; // Custom Location Name
  streetAddress1?: string; // Intersection Street Address
  order?: number | null; // Custom Address Order for 1* ~ 8*
  index?: number; // Custom Address Index for 1* ~ 8*
  isShow?: boolean; // Flag to Show Custom Address or Not
  type?: boolean; // Flag for Intersection Form or Not
  phoneNumber?: string; // Location Phone Number
  noteToDriver?: string; // Ride Note to Driver About Address
  gourmetNoteToDriver?: string; // Gourmet Note to Driver About Address
  coordinatesChanges?: Record<string, any>;
  isAirport?: boolean;
  createdAt?: string;
  [key: string]: any;
}

export enum AddressType {
  PickUp = 0,
  DropOff = 1,
}

interface SubsidyLocationData {
  noSubsidy?: boolean;
  locationCode?: string;
}

export interface SubsidyLocation {
  name: string;
  phoneNumber: string;
  streetAddress: string;
  streetAddress2: string | null;
  city: string;
  state: string;
  zip: string;
  country: string;
  latitude: number;
  longitude: number;
  radius: number;
  placeType: string;
  data: SubsidyLocationData;
}
